<template lang="html">
  <img :src="current"
       alt=""
       class="ai-image-button"
       @mouseover="current = pressed"
       @mouseout="current = idle"
       @click="$emit('click')">
</template>

<script>
export default {
  name: 'AiImageButton',
  props: {
    idle: {
      type: String,
      default: ''
    },
    pressed: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      current: this.idle
    };
  }
};
</script>
